import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$city/$district')({
  component: () => <Outlet />,
});
